import { FilterPoint } from "../types/types";
import { filterTypes } from "./filtertypes";

export interface IFilterState {
    filter: FilterPoint 
}

export const initialState: IFilterState = {
    filter: {}
}

export const filterReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case filterTypes.SET_FILTER:
            return {
                ...state,
                filter: action.payload
            }
        default:
            return state
    }
}

export default filterReducer